import { Box, Container, IconButton, Link, Stack, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import Logo from "../assets/logo.png";
import FacebookIcon from "@mui/icons-material/FacebookOutlined";
import InstagramInIcon from "@mui/icons-material/Instagram";
import { imagenesModalFooter } from "../data/data";
import ModalImagenes from "./ModalImagenes";
import Mapa from "./Mapa";
//import MedicalSearch from "./medical-search/MedicalSearch"
import {ScrollStatic} from "./common/ScrollItem";

const logoStyle = {
  width: "100px",
  height: "auto",
};

function Copyright() {
  return (
    <Typography variant="body2" color="secondary" mt={1}>
      {"© "}
      Centro Quirurgico San Rafael. Todos los Derechos Reservados&nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const isMobile = useMediaQuery("(max-width:900px)");
  const [openModal, setOpenModal] = useState(false);
  const [imagenesActuales, setImagenesActuales] = useState([]);

  const handleOpenModal = (imagenes) => {
    setImagenesActuales(imagenes);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setImagenesActuales([]);
  };

  return (
    <Box
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >

      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, sm: 4 },
          py: { xs: 4, sm: 3 },
          textAlign: { sm: "center", md: "left" },
          maxWidth: "none !important",
        }}
      >
        <Stack spacing={{ xs: '20px'}}
          sx={{
            display: "flex",
            // flexDirection: { xs: "column", sm: "row" },
            flexDirection: isMobile ? "column" : "row",
            width: "100%",
            justifyContent: "center",
            maxWidth: "1200px",
          }}
        >
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            minWidth: { xs: "100%", sm: "40%", lg: "45%" },
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}>
            <Box sx={{ width: { xs: "100%", sm: "50%" }, justifyItems: "center",}}>
              <Box sx={{ ml: "-15px" }}>
                <img src={Logo} style={logoStyle} alt="logo de Centro Quirurgico San Rafael" />
              </Box>
              <Typography variant="h5" fontWeight={600} gutterBottom color="rgb(25, 91, 224)">
                "Nuestra prioridad es tu bienestar."
              </Typography>
              <Box sx={{ width: "300px", textAlign: "justify" }}>
                <Typography variant="caption" color="text.secondary" mb={2} fontSize={14}>
                  En Centro Quirúrgico San Rafael estamos preparados para tu
                  atención médica las 24 horas, los 365 días del año,
                  respaldados por un equipo de médicos profesionales altamente
                  capacitados y equipo de última tecnología.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minWidth: { xs: "100%", sm: "60%", lg: "55%" },
            gap: "8px",
            textAlign: "center",
            // mt:{xs:"18px", sm:"18px"}
          }}>
            <Typography variant="h5" fontWeight={600}>
              Ubicación
            </Typography>
            <Mapa />
          </Box>
        </Stack>

        <Box
          sx={{
            display: "flex",
            pt: { xs: 2, sm: 4 },
            width: "100%",
            borderTop: "1px solid",
            borderColor: "divider",
            justifyContent: "center",
            //justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              paddingRight: "30px",
            }}
          >
            <Link
              color="text.secondary"
              variant="h6"
              href="#"
              onClick={() => handleOpenModal(imagenesModalFooter.terminos)}
            >
              Términos y Condiciones
            </Link>

            <Typography display="inline" sx={{ mx: 0.5, opacity: 0.5 }}>
              &nbsp;•&nbsp;
            </Typography>

            <Link
              color="text.secondary"
              variant="h6"
              href="#"
              onClick={() => handleOpenModal(imagenesModalFooter.privacidad)}
            >
              Aviso de Privacidad
            </Link>


            <Typography display="inline" sx={{ mx: 0.5, opacity: 0.5 }}>
              &nbsp;•&nbsp;
            </Typography>

            <Link
              color="text.secondary"
              variant="h6"
              href="#"
              onClick={() => handleOpenModal(imagenesModalFooter.acerca)}
            >
              Política de Cookies
            </Link>

            <ModalImagenes
              open={openModal}
              handleClose={handleCloseModal}
              imagenes={imagenesActuales}
              // disableScrollLock
              // disableAutoFocus={true}
              // disableEnforceFocus={true}
            />
            <Copyright />
          </Box>

          <Stack
            direction="row"
            justifyContent="left"
            spacing={1}
            useFlexGap
            sx={{
              color: "secondary",
            }}
          >
            <IconButton
              color="inherit"
              href="https://www.facebook.com/SanRafaelCQ"
              aria-label="GitHub"
              sx={{ alignSelf: "center" }}
            >
              <FacebookIcon />
            </IconButton>
            {/* <IconButton
              color="inherit"
              href="/"
              aria-label="X"
              sx={{ alignSelf: "center" }}
            >
              <TwitterIcon />
            </IconButton> */}
            <IconButton
              color="inherit"
              href="https://www.instagram.com/sanrafaelcq/"
              aria-label="LinkedIn"
              sx={{ alignSelf: "center" }}
            >
              <InstagramInIcon />
            </IconButton>
          </Stack>
        </Box>

        {/* <Box
          sx={{
            display: "flex",
            pt: { xs: 1, sm: 2 },
            width: "100%",
            borderTop: "1px solid",
            borderColor: "divider",
            justifyContent: "center",
          }}
        >
          <Typography color="secondary">Desarrollado por: <a href="https://github.com/carneasada123" target="_blank" rel="noreferrer">Alan Josue Rodriguez</a></Typography>
        </Box> */}

      </Container>
    </Box>
  );
}
